import { FunctionComponent, useContext } from 'react';

import { CommentIcon } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { IComment } from 'types';

import { CollapsibleItem } from '../CollapsibleItem';
import s from './Comment.module.scss';

interface ICommentProps {
  comment?: Pick<IComment, 'text' | 'is_important'> | null;
  defaultState?: boolean;
}

export const Comment: FunctionComponent<ICommentProps> = ({
  comment,
  defaultState,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <CollapsibleItem
      title={t('client.comment')}
      Icon={CommentIcon}
      color={comment ? 'blue' : undefined}
      defaultState={defaultState}
      comment={comment}
    >
      {comment?.text ? (
        <div className={s.comment}>{comment.text}</div>
      ) : (
        t('client.comment.placeholder')
      )}
    </CollapsibleItem>
  );
};
